import utility from '../shared/utility';

class Branch {
  accountCreatedEventName = 'br_account_created';

  subscriptionCreatedEventName = 'br_subscription_created';

  createLink(type, shareData) {
    return new Promise((resolve, reject) => {
      const linkData = {
        campaign: 'Beta',
        channel: 'web',
        feature: 'share',
        alias: '',
        data: shareData,
      };
      const { token } = window.$store.getters;
      if (token) {
        const { user } = window.$store.getters;
        if (user && user.uuid) {
          linkData.data.user_uuid = user.uuid;
        }
      }
      if (window.branch) {
        window.branch.link(linkData, (err, link) => {
          if (err) {
            reject(err);
          } else if (link) {
            resolve(link);
          }
        });
      } else {
        reject(new Error('sdk not found'));
      }
    });
  }

  readDeeplink() {
    return new Promise((resolve, reject) => {
      if (window.branch) {
        window.branch.data((err, data) => {
          if (data) {
            if (window && window.$store) {
              window.$store.dispatch('setBranchData', data.data_parsed);
            }
            resolve(data);
          } else {
            reject(err);
          }
        });
      } else {
        reject(new Error('sdk not found'));
      }
    });
  }

  logCustomEvent(eventName, customData) {
    customData = utility.removeEmpty(customData);
    if (window.branch) {
      window.branch.logEvent(eventName, customData);
    }
  }
}

export default Branch;
